import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, MessageCircle, Copy } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const ShareCardDialog = ({ product, open, onOpenChange }) => {
  const [loaded, setLoaded] = useState(false);
  const cardUrl = `${API}/api/share/product/${product.id}/milestone.png`;
  const productUrl = `${window.location.origin}/product/${product.id}`;
  const views = product.views || 0;
  const label = [10000, 5000, 1000, 500, 100, 50].find((m) => views >= m);
  const caption = `${label ? `${label.toLocaleString()}+` : views} buyers have viewed "${product.title}" on VISMARKS. Get yours before it's gone — buyer protection on every order: ${productUrl}`;

  const copy = () => navigator.clipboard.writeText(caption).then(() => toast.success("Caption copied — paste it with the image"));
  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(caption)}`, "_blank", "noopener");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-[#0E0E10] border-[#27272A]" data-testid="share-card-dialog">
        <DialogHeader><DialogTitle>Share card — {product.title}</DialogTitle></DialogHeader>
        <div className="rounded-xl overflow-hidden border border-[#27272A] bg-[#121212] aspect-square">
          {!loaded && <div className="h-full w-full flex items-center justify-center text-sm text-neutral-500">Rendering your card…</div>}
          <img src={cardUrl} alt={`${product.title} views share card`} onLoad={() => setLoaded(true)} className={`h-full w-full object-cover ${loaded ? "" : "hidden"}`} data-testid="share-card-image" />
        </div>
        <p className="text-xs text-neutral-500">Download the image, then post it with the caption. WhatsApp opens with the caption ready — attach the downloaded image.</p>
        <div className="flex flex-wrap gap-2">
          <a href={cardUrl} download={`vismarks-${views}-views.png`} target="_blank" rel="noopener noreferrer">
            <Button data-testid="share-card-download" className="rounded-full bg-white text-black hover:bg-neutral-200 font-semibold"><Download className="h-4 w-4 mr-2" /> Download image</Button>
          </a>
          <Button onClick={whatsapp} data-testid="share-card-whatsapp" className="rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-black font-semibold"><MessageCircle className="h-4 w-4 mr-2" /> Share to WhatsApp</Button>
          <Button onClick={copy} variant="outline" data-testid="share-card-copy" className="rounded-full border-white/20 bg-transparent text-white hover:bg-white/5 hover:text-white"><Copy className="h-4 w-4 mr-2" /> Copy caption</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
